import { Injectable, inject } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import {
  AssetSummary,
  ConnectorApi,
  ConnectorDashboard,
  PartnerSummary,
  TransferSummary
} from '@adesso/dataspace-api-client';
import { ADESSO_API_CONFIG } from '../../../../core/api/adesso-api.config';
import {
  DashboardData,
  PopularAsset,
  RecentTransfer,
  TopPartner
} from '../models/dashboard-data.model';
import { DashboardApiPort } from '../ports/dashboard-api.port';

@Injectable()
export class AdessoDashboardApiAdapter extends DashboardApiPort {
  private readonly api = new ConnectorApi(inject(ADESSO_API_CONFIG));

  getDashboardData(): Observable<DashboardData> {
    return from(this.api.getDashboard()).pipe(map((res) => toDomain(res.data)));
  }
}

function toDomain(dto: ConnectorDashboard): DashboardData {
  return {
    assetCount: dto.assetCount ?? 0,
    policyCount: dto.policyCount ?? 0,
    contractDefinitionCount: dto.contractDefinitionCount ?? 0,
    transferCount: dto.transferCount ?? 0,
    agreementCount: dto.contractAgreementCount ?? 0,
    transfersByOutcome: dto.transfersByOutcome ?? {},
    transfersByType: dto.transfersByType ?? {},
    uptimeMillis: dto.uptimeMillis ?? 0,
    topPartners: (dto.topPartners ?? []).map(toTopPartner),
    recentTransfers: (dto.recentTransfers ?? []).map(toRecentTransfer),
    popularAssets: (dto.popularAssets ?? []).map(toPopularAsset),
    transferSuccessRate: dto.transferSuccessRate ?? 0,
    lastActivityTimestamp: dto.lastActivityTimestamp ?? 0
  };
}

function toTopPartner(p: PartnerSummary): TopPartner {
  return {
    bpnl: p.partnerId ?? '',
    organizationName: p.organizationName ?? p.partnerId ?? '',
    agreementCount: p.agreementCount ?? 0
  };
}

function toRecentTransfer(t: TransferSummary): RecentTransfer {
  return {
    transferId: t.transferId ?? '',
    assetId: t.assetId ?? '',
    contractId: t.contractId ?? '',
    outcome: t.outcome ?? '',
    type: t.transferType ?? '',
    stateTimestamp: t.stateTimestamp ?? 0
  };
}

function toPopularAsset(a: AssetSummary): PopularAsset {
  return {
    assetId: a.assetId ?? '',
    assetName: a.name ?? a.assetId ?? '',
    transferCount: a.transferCount ?? 0
  };
}
